import { MutableRefObject, useImperativeHandle, useRef } from 'react';

export const useLatestRef = <T = any>(value: T): MutableRefObject<T> => {
  const ref = useRef(value);

  useImperativeHandle(ref, () => value, [value]);

  return ref;
};
